import axios from 'axios';
import { API_PATH } from '../../../constants';
import * as actions from './actions';

export const getCurrentUser = () => (dispatch, getState) => {
  const lastFetchAgo = Date.now() - getState().currentUser.lastFetch;
  if (lastFetchAgo < 60 * 1000) {
    console.log(`Still fresh currentUser: not fetching`);
    return Promise.resolve();
  } else {
    return axios
      .get(`${API_PATH}/users/current`)
      .then(response => dispatch(actions.currentUserReceived(response.data)));
  }
};
